const getAnalyticData = (key, formValues1) => {
  let temp1 = '';
  formValues1[key]?.forEach((item) => {
    temp1 += `${item}:`;
  });
  return temp1;
};

const getBopisCheck = (formValues1, temp, key) => {
  return formValues1[key].length === 0 ? '' : `${temp}^`;
};

const getAnalyticString = (key, temp, formValues1, analyticString) => {
  let analyticStringNew = analyticString;
  const temp1 = getAnalyticData(key, formValues1);
  analyticStringNew += `${temp}=${temp1?.substring(0, temp1.length - 1)}^`;
  return analyticStringNew;
};

const caseMappings = {
  bopisStoreId: (formValues1, analyticString) =>
    analyticString + getBopisCheck(formValues1, 'bopis', 'bopisStoreId'),
  sort: (formValues1, analyticString) => `${analyticString}sort=${formValues1?.sort}^`,
  v_tcpsize_uFilter: (formValues1, analyticString) =>
    getAnalyticString('v_tcpsize_uFilter', 'size', formValues1, analyticString),
  categoryPath1_uFilter: (formValues1, analyticString) =>
    getAnalyticString('categoryPath1_uFilter', 'department', formValues1, analyticString),
  min_offer_price: (formValues1, analyticString) =>
    getAnalyticString('min_offer_price', 'price', formValues1, analyticString),
  TCPColor_uFilter: (formValues1, analyticString) =>
    getAnalyticString('TCPColor_uFilter', 'color', formValues1, analyticString),
  v_tcpfit_unbxd_uFilter: (formValues1, analyticString) =>
    getAnalyticString('v_tcpfit_unbxd_uFilter', 'fit', formValues1, analyticString),
  TCPStyleQTYUS_uFilter: (formValues1, analyticString) =>
    getAnalyticString('TCPStyleQTYUS_uFilter', 'mpacks', formValues1, analyticString),
  categoryPath2_uFilter: (formValues1, analyticString) =>
    getAnalyticString('categoryPath2_uFilter', 'category', formValues1, analyticString),
  age_group_uFilter: (formValues1, analyticString) =>
    getAnalyticString('age_group_uFilter', 'age', formValues1, analyticString),
  gender_uFilter: (formValues1, analyticString) =>
    getAnalyticString('gender_uFilter', 'gender', formValues1, analyticString),
  TCPProductIndUSStore_uFilter: (formValues1, analyticString) =>
    getAnalyticString('TCPProductIndUSStore_uFilter', 'sdeals', formValues1, analyticString),
  TCPPrimaryBrandUSStore_uFilter: (formValues1, analyticString) =>
    getAnalyticString('TCPPrimaryBrandUSStore_uFilter', 'brand', formValues1, analyticString),
  v_clothingsize_uFilter: (formValues1, analyticString) =>
    getAnalyticString('v_clothingsize_uFilter', 'clothingsize', formValues1, analyticString),
  v_shoessize_uFilter: (formValues1, analyticString) =>
    getAnalyticString('v_shoessize_uFilter', 'shoessize', formValues1, analyticString),
  v_accessoriessize_uFilter: (formValues1, analyticString) =>
    getAnalyticString('v_accessoriessize_uFilter', 'accessoriessize', formValues1, analyticString),
  productTypeCategory_uFilter: (formValues1, analyticString) =>
    getAnalyticString('productTypeCategory_uFilter', 'producttype', formValues1, analyticString),
  TCPBazaarVoiceRating_inText_uFilter: (formValues1, analyticString) =>
    getAnalyticString(
      'TCPBazaarVoiceRating_inText_uFilter',
      'customerrating',
      formValues1,
      analyticString
    ),
  categoryPrimaryL2_uFilter: (formValues1, analyticString) =>
    getAnalyticString('categoryPrimaryL2_uFilter', 'primarycategory', formValues1, analyticString),
  influencer_name_uFilter: (formValues1, analyticString) =>
    getAnalyticString('influencer_name_uFilter', 'influencerpicks', formValues1, analyticString),
  influencer_handle_uFilter: (formValues1, analyticString) =>
    getAnalyticString('influencer_handle_uFilter', 'influencerpicks', formValues1, analyticString),
  responsibly_sourced_uFilter: (formValues1, analyticString) =>
    getAnalyticString('responsibly_sourced_uFilter', 'betterfuture', formValues1, analyticString),
  v_tcpfit_uFilter: (formValues1, analyticString) =>
    getAnalyticString('v_tcpfit_uFilter', 'fit', formValues1, analyticString),
  influencer_pick_uFilter: (formValues1, analyticString) =>
    getAnalyticString('influencer_pick_uFilter', 'influencerpick', formValues1, analyticString),
};
const getAnalyticStringFromFormValues = (formValues1, analyticString, key) => {
  const mappingFunction = caseMappings[key] || (() => '');
  return mappingFunction(formValues1, analyticString);
};

const createPayload = (formValues1) => {
  let analyticString = '';
  // eslint-disable-next-line no-restricted-syntax
  for (const key in formValues1) {
    if (formValues1) {
      if (formValues1.length > 1) {
        analyticString += `${analyticString}^`;
      }
      if (formValues1[key]?.length > 0) {
        analyticString = getAnalyticStringFromFormValues(formValues1, analyticString, key);
      }
    }
  }
  analyticString = analyticString?.substring(0, analyticString.length - 1);
  return analyticString;
};

export default createPayload;
